export {
  CanvasContext,
  HEIGHT,
  SCALE,
  WIDTH,
} from './CanvasContext'
